import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const pains = [{
    icon: '😤',
    title: 'Te dicen "en otra clínica cobran menos"',
    desc: 'Y no sabés cómo responder sin bajar el precio ni perder al cliente.'
  }, {
    icon: '😰',
    title: 'Tenés que dar un diagnóstico grave',
    desc: 'Y no existe ningún protocolo. Improvisás y te quedás con eso encima el resto del día.'
  }, {
    icon: '📱',
    title: 'El dueño llega con el diagnóstico de TikTok',
    desc: 'Y si lo contradecís se cierra. Si no lo hacés perdés autoridad clínica.'
  }, {
    icon: '📞',
    title: 'Las llamadas post-consulta no paran',
    desc: 'Porque el propietario salió sin entender bien el tratamiento ni cuándo tiene que preocuparse.'
  }, {
    icon: '😢',
    title: 'El propietario se desborda emocionalmente',
    desc: 'Y vos no sabés si contenerlo, seguir con la consulta o simplemente esperar.'
  }, {
    icon: '💸',
    title: 'Hablar de plata te incomoda',
    desc: 'Estudiaste para curar animales, no para negociar presupuestos. Y eso te está costando plata.'
  }, {
    icon: '🤷',
    title: 'Los tratamientos no se cumplen',
    desc: 'El dueño asintió con la cabeza y no entendió nada. El animal vuelve sin mejoría.'
  }, {
    icon: '🔋',
    title: 'Terminás el día agotado emocionalmente',
    desc: 'No por el trabajo clínico — sino por el desgaste de cada conversación difícil sin herramientas.'
  }];
  return <section className="bg-[#fafafa] py-10 sm:py-16 px-5" data-id="element-177">
      <div className="max-w-6xl mx-auto" data-id="element-178">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-179">
          ¿Te pasa esto?
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-4 sm:mb-6 leading-tight" data-id="element-180">
          Si trabajás en clínica veterinaria en Argentina,
          <br className="hidden sm:block" data-id="element-181" />
          esto te suena familiar
        </h2>

        <div className="max-w-2xl mx-auto mb-8 sm:mb-12 text-center" data-id="element-182">
          <p className="text-sm sm:text-lg text-gray-700 leading-relaxed" data-id="element-183">
            El problema no es tu conocimiento clínico. El problema es que nadie
            te enseñó qué decir cuando la consulta deja de ser técnica y se
            convierte en una conversación humana difícil.
          </p>
        </div>

        <div className="grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 mb-8 sm:mb-10" data-id="element-184">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05,
          duration: 0.3
        }} whileHover={{
          borderColor: '#ffb3b3',
          boxShadow: '0 4px 20px rgba(192,57,43,0.08)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-white rounded-xl p-4 sm:p-6 border border-gray-200 flex gap-3 sm:gap-4 items-start transition-colors cursor-default" data-id="element-185">
              <div className="text-xl sm:text-2xl flex-shrink-0 mt-0.5" data-id="element-186">
                {pain.icon}
              </div>
              <div data-id="element-187">
                <h4 className="font-semibold text-sm sm:text-base text-navy mb-0.5 sm:mb-1" data-id="element-188">
                  {pain.title}
                </h4>
                <p className="text-[11px] sm:text-sm text-gray leading-snug" data-id="element-189">
                  {pain.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-190">
          <p className="text-base sm:text-lg font-semibold text-navy mb-1 sm:mb-1.5" data-id="element-191">
            ¿Cuántas consultas más vas a improvisar?
          </p>
          <span className="text-xs sm:text-base text-gray" data-id="element-192">
            Esto tiene solución — y está en el próximo tomo que abrís.
          </span>
        </div>
      </div>
    </section>;
}